// extracted by mini-css-extract-plugin
module.exports = {"content6":"styles_content6__1lQF_","article":"styles_article__3aeUP","section":"styles_section__1yMBb","box2":"styles_box2__1RJdT"};